import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Map from './components/Map';
import GeolocationGuide from './pages/GeolocationGuide';
import './components/Map.css';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Map />} />
        <Route path="/geolocation-guide" element={<GeolocationGuide />} />
      </Routes>
    </Router>
  );
}

export default App;
